module.exports = __webpack_public_path__ + "static/img/Chad-Wingard.77a7efc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Chad-Wingard.jpg
// module id = F387
// module chunks = 0